import { ServiceMaker, methods, services } from "@/services";

export const createLibrary = data =>
  ServiceMaker(
    "/api/photo-library/create",
    methods.POST,
    services.catalog,
    data
  );

export const updateLibrary = data =>
  ServiceMaker(
    `/api/photo-library/update/${data.id}`,
    methods.PUT,
    services.catalog,
    data.data
  );

  export const listLibrary = data =>
  ServiceMaker(
    `/api/photo-library/list?catalogId=${data}`,
    methods.GET,
    services.catalog
  );


  export const detailLibrary = Id =>
  ServiceMaker(
    `/api/photo-library/detail/${Id}`,
    methods.GET,
    services.catalog
  );



  export const deleteLibrary = Id =>
  ServiceMaker(
    `/api/photo-library/delete/${Id}`,
    methods.DELETE,
    services.catalog
  );
